var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"reportWrapper"}},[_c('tree-item',{attrs:{"data":_vm.tree,"level":0}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }